


export const CommonCircle = () => {
    return (

        <>
            {/* <i class="fa-solid fa-circle pe-2 circle_color" ></i> */}
            <img src="static/assets/img/bullet-point.png" className='lightgreencolor me-1' alt="science" width="16vw" />

        </>

    )
}

export const Circle = () => {
    return (

        <>
            <i class="fa-solid fa-circle pe-2 " style={{fontSize:"8px"}} ></i>
            {/* <img src="static/assets/img/bullet-point.png" className='lightgreencolor me-1' alt="science" width="16vw" /> */}

        </>

    )
}

